import { Input, InputDescriptionWrap, Text } from 'components'
import { inputDescriptions } from './inputDescriptions'

export const OwnerInfoStep = () => {
  return (
    <>
      <Text fontSize={14} textAlign="left">
        That’s it – what remains are your contact details. If someone is
        interested in booking your property or has any questions, we will use
        this as a main point of contact.
      </Text>

      <InputDescriptionWrap text={inputDescriptions.ownerInfo.name}>
        <Input
          isBlock
          label="Your Name"
          name="name"
          placeholder="Enter your name"
        />
      </InputDescriptionWrap>

      <InputDescriptionWrap text={inputDescriptions.ownerInfo.email}>
        <Input
          isBlock
          label="Your Email"
          name="email"
          type="email"
          placeholder="Enter your email"
        />
      </InputDescriptionWrap>

      <InputDescriptionWrap text={inputDescriptions.ownerInfo.phone}>
        <Input
          isBlock
          label="Phone number"
          name="phone"
          placeholder="Enter phone number"
        />
      </InputDescriptionWrap>
    </>
  )
}
